/** The longest delay setTimeout honours; a larger one fires immediately. */
export const MAX_TIMER_DELAY_MS = 2_147_483_647;

/** Zero for a past, missing or unparseable expiry, so the caller re-checks at once. */
export function millisecondsUntilExpiry(expiresAt: string | null | undefined, now: number): number {
    const expiry = expiresAt ? Date.parse(expiresAt) : Number.NaN;
    if (Number.isNaN(expiry)) return 0;

    return Math.min(Math.max(expiry - now, 0), MAX_TIMER_DELAY_MS);
}

export function hasExpired(expiresAt: string | null | undefined, now: number): boolean {
    return millisecondsUntilExpiry(expiresAt, now) === 0;
}
